import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Home.css';

import { LSystem, LSystemGenome } from '../core/LSystem';
import { useEffect, useState } from 'react';

let g_LSystem = new LSystem();

let g_Genome: LSystemGenome = g_LSystem.genome();


const NUM_GENERATIONS: number = 4;

function reinitialise()
{
  let totalLines: number = 0;
  while (totalLines <= 100)
  {
    g_Genome.randomise();
    g_LSystem.updateFromGenome(g_Genome);
    let lines = g_LSystem.linesForGeneration(NUM_GENERATIONS, 100, 200, -90);
    totalLines = lines.length;
  }

  console.log(g_Genome);
}

reinitialise();


const Home: React.FC = () => {
  const [coords, setCoords] = useState<number[][]>([[0, 0, 100, 100]]);

  console.log(coords.length);

  const left: number = coords.map(x => Math.min(x[0], x[2])).reduce((prev, curr) => Math.min(prev, curr));
  const right: number = coords.map(x => Math.max(x[0], x[2])).reduce((prev, curr) => Math.max(prev, curr));
  const top: number = coords.map(x => Math.min(x[1], x[3])).reduce((prev, curr) => Math.min(prev, curr));
  const bottom: number = coords.map(x => Math.max(x[1], x[3])).reduce((prev, curr) => Math.max(prev, curr));

  const xRange: number = right - left;
  const yRange: number = bottom - top;
  const xCentre: number = (left + right) / 2.0;
  const yCentre: number = (top + bottom) / 2.0;
  const maxRange: number = Math.max(xRange, yRange) * 1.2; // include margin
  const r: number = maxRange / 2.0;

  const viewBoxStr: string = `${xCentre - r} ${yCentre - r} ${maxRange} ${maxRange}`;
  const lineSegments = coords.map((x, i) => <line key={i} x1={x[0]} y1={x[1]} x2={x[2]} y2={x[3]}/>);

  function handleClick()
  {
    reinitialise();
    setCoords(g_LSystem.linesForGeneration(NUM_GENERATIONS, 100, 200, -90));
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>L-Systems</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {/* <svg xmlns="http://www.w3.org/2000/svg"  version="1.1" width={`${w}px`} height={`${h}px`} viewBox={viewBoxStr} > */}
        <svg xmlns="http://www.w3.org/2000/svg"  version="1.1" width="100%" viewBox={viewBoxStr} onClick={() => handleClick()}>
        <defs/>
          <g>
          {lineSegments}
          </g>

        </svg>
        <p>{g_LSystem.generation(NUM_GENERATIONS)}</p>
      </IonContent>
    </IonPage>
  );
};

export default Home;
